<template>
    <div
        v-if="visible"
        :style="popupStyle"
        class="popupAct"
        @click.stop
    >
        <q-bar class="bg-primary text-white q-mb-xs">
            <div class="text-subtitle1 text-weight-medium">
                {{ data.id }}
            </div>
            <q-space />
            <q-btn
                dense
                flat
                color="white"
                icon="close"
                @click.stop="handleClickClose"
            />
        </q-bar>
        <q-inner-loading
            v-if="isLoading"
            :showing="isLoading"
            :style="{ zIndex: 1000 }"
            visible
        />
        <div
            v-else
        >
            <div class="row justify-center q-mb-sm">
                <div class="row items-center q-pa-md">
                    <p style="font-size: medium; font-weight: bold">
                        {{ $t('visualization.popup.impact.title') }}
                    </p>
                </div>
                <div class="column items-center">
                    {{ $t('visualization.popup.impact.current') }}
                    <q-circular-progress
                        :value="currentWallaceCofPercent"
                        size="45px"
                        :thickness="0.2"
                        :color="severityColors[0]"
                        class="q-ma-md"
                        showValue
                    >
                        <div
                            class="q-mt-sm"
                            style="color: #000000; font-size: 14px;"
                        >
                            {{ currentWallaceCofPercent }}%
                        </div>
                        <q-tooltip>
                            {{ currentWallaceCofPercent }}{{ $t('visualization.popup.impact.currentImpact') }}
                        </q-tooltip>
                    </q-circular-progress>
                    {{ $t(`visualization.popup.impact.level.${severityLevels[0]}`) }}
                </div>
                <div class="column items-center">
                    {{ $t('visualization.popup.impact.total') }}
                    <q-circular-progress
                        :value="totalWallaceCofPercent"
                        size="45px"
                        :thickness="0.2"
                        :color="severityColors[1]"
                        class="q-ma-md"
                        showValue
                    >
                        <div
                            class="q-mt-sm"
                            style="color: #000000; font-size: 14px;"
                        >
                            {{ totalWallaceCofPercent }}%
                        </div>
                        <q-tooltip>
                            {{ totalWallaceCofPercent }}{{ $t('visualization.popup.impact.totalImpact') }}
                        </q-tooltip>
                    </q-circular-progress>
                    {{ $t(`visualization.popup.impact.level.${severityLevels[1]}`) }}
                </div>
            </div>
            <div
                class="buttons_container q-gutter-sm q-mx-sm"
            >
                <div class="button_row">
                    <q-btn
                        :color="isFilterApplied[0] ? 'grey-7' : 'primary'"
                        icon="hourglass_top"
                        :label="$t('visualization.popup.buttons.start_with')"
                        :disable="isStartWithFilterApplied"
                        unelevated
                        noCaps
                        class="q-mr-sm"
                        @click="handleAddFilter('TRACE_STARTS_WITH_ACTIVITY')"
                    />
                    <span style="margin-left: 10px">{{ casesValue.startsWith }} cases</span>
                </div>
                <div class="button_row">
                    <q-btn
                        :color="isFilterApplied[1] ? 'grey-7' : 'primary'"
                        icon="hourglass_bottom"
                        :label="$t('visualization.popup.buttons.end_with')"
                        :disable="isEndWithFilterApplied"
                        unelevated
                        noCaps
                        class="q-mr-sm"
                        @click="handleAddFilter('TRACE_ENDS_WITH_ACTIVITY')"
                    />
                    <span style="margin-left: 10px">{{ casesValue.endsWith }} cases</span>
                </div>
                <div class="button_row">
                    <q-btn
                        :color="isFilterApplied[2] ? 'grey-7' : 'primary'"
                        icon="check_box"
                        :disable="isContainFilterApplied"
                        :label="$t('visualization.popup.buttons.contain')"
                        unelevated
                        noCaps
                        class="q-mr-sm"
                        @click="handleAddFilter('TRACE_CONTAINS_ACTIVITIES')"
                    />
                    <span style="margin-left: 10px">{{ casesValue.contains }} cases</span>
                </div>
                <div class="button_row">
                    <q-btn
                        :color="isFilterApplied[3] ? 'grey-7' : 'primary'"
                        icon="disabled_by_default"
                        :disable="isNotContainFilterApplied"
                        :label="$t('visualization.popup.buttons.not_contain')"
                        unelevated
                        noCaps
                        class="q-mr-sm"
                        @click="handleAddFilter('TRACE_NOT_CONTAINS_ACTIVITIES')"
                    />
                    <span style="margin-left: 10px">{{ casesValue.notContains }} cases</span>
                </div>
                <div
                    class="button_row connections"
                >
                    <q-btn
                        v-if="data"
                        flat
                        noCaps
                        color="primary"
                        class="connectionButton"
                        :label="$t('visualization.popup.buttons.connections')"
                        icon="link"
                        @click="handleClickTablePopup()"
                    />
                    <q-inner-loading :showing="!data" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueTypes from 'vue-types'
import {
    Api, apiRequest, notifyError,
} from '@/api'
import { filtersStorageMixin } from '@/mixins'

export default {
    name: 'PopUp',
    components: {
    },
    mixins: [filtersStorageMixin],
    props: {
        data: VueTypes.object,
        visible: VueTypes.bool,
        position: VueTypes.object,
        tab: VueTypes.string,
    },
    emits: ['close', 'addFilter', 'open-table-popup'],
    data() {
        return {
            isLoading: false,
            currentWallaceCofPercent: 0,
            totalWallaceCofPercent: 0,
            severityLevels: ["low", "low"],
            severityColors: ["green", "green"],
            casesValue: {
                startsWith: 0,
                endsWith: 0,
                contains: 0,
                notContains: 0,
            },
            isFilterApplied: [false, false, false, false],
            filters: [],
            isBlocked: [false, false, false, false],
            extendedPopUp: false,
        }
    },
    computed: {
        popupStyle() {
            return {
                left: `${this.position.x}px`,
                top: `${this.position.y}px`,
            }
        },
        isContainFilterApplied() {
            const activityId = this.data?.id
            if (!activityId) return false
            const { visualizationFilters } = this
            return (visualizationFilters || []).some((filter) => {
                if (!filter || filter.id !== 'TRACE_CONTAINS_ACTIVITIES') return false

                // Canonical: values is always an array
                if (Array.isArray(filter.values) && filter.values.includes(activityId)) return true

                // Legacy fallbacks
                if (Array.isArray(filter.key) && filter.key.includes(activityId)) return true
                if (filter.value === activityId) return true
                if (Array.isArray(filter.type?.category) && filter.type.category.includes(activityId)) return true
                return false
            })
        },
        isNotContainFilterApplied() {
            const activityId = this.data?.id
            if (!activityId) return false
            const { visualizationFilters } = this
            return (visualizationFilters || []).some((filter) => {
                if (!filter || filter.id !== 'TRACE_NOT_CONTAINS_ACTIVITIES') return false

                // Canonical: values is always an array
                if (Array.isArray(filter.values) && filter.values.includes(activityId)) return true

                // Legacy fallbacks
                if (Array.isArray(filter.key) && filter.key.includes(activityId)) return true
                if (filter.value === activityId) return true
                if (Array.isArray(filter.type?.category) && filter.type.category.includes(activityId)) return true
                return false
            })
        },
        isStartWithFilterApplied() {
            const { visualizationFilters } = this
            const actFilter = visualizationFilters.find((filt) => (filt.id === 'TRACE_STARTS_WITH_ACTIVITY'))
            return !!actFilter
        },
        isEndWithFilterApplied() {
            const { visualizationFilters } = this
            const actFilter = visualizationFilters.find((filt) => (filt.id === 'TRACE_ENDS_WITH_ACTIVITY'))
            return !!actFilter
        },
    },
    watch: {
        tab() {
            if (this.visible) {
                this.handleClickClose()
            }
        },
        visible(newVal) {
            if (newVal) {
                this.applyFilters()
                this.getImpactFromWallaceCof()
            }
        },
        data() {
            this.applyFilters()
            this.getImpactFromWallaceCof()
        },
        currentWallaceCofPercent() {
            this.calculateSeverityLevel()
        },
        totalWallaceCofPercent() {
            this.calculateSeverityLevel()
        },
    },
    methods: {
        getImpactFromWallaceCof() {
            this.isLoading = true
            const { processId } = this.$route.params
            const { variantCount: variants, variantUid: variantsId, loopUid: loopId } = this.data?.modelData || {}
            const activityName = this.formatActivityName(this.data.id)
            const params = this.buildVisualizationParams({
                ...(variants && { variants }),
                ...(variantsId && { variantsId }),
                ...(loopId && { loopId }),
            })
            this.currentFilters = params.filters
            Api().visualizations.activityImpactWallaceCof({ processId, activityName, params })
                .then((data) => {
                    const cw = data?.data?.data?.[0]?.currentCW
                    this.currentWallaceCofPercent = cw != null ? Math.round(cw * 100) : 0
                    const totalCw = data?.data?.data?.[0]?.totalCW
                    this.totalWallaceCofPercent = totalCw != null ? Math.round(totalCw * 100) : 0
                }).catch(notifyError)
                .finally(() => {
                    this.isLoading = false
                })
        },

        formatActivityName(name) {
            return encodeURIComponent(name)
        },
        async applyFilters() {
            try {
                const filters = [
                    'TRACE_STARTS_WITH_ACTIVITY',
                    'TRACE_ENDS_WITH_ACTIVITY',
                    'TRACE_CONTAINS_ACTIVITIES',
                    'TRACE_NOT_CONTAINS_ACTIVITIES',
                ]

                const promises = filters.map((filter) => this.filterCases(filter))

                await Promise.all(promises)
                    .then((results) => {
                        this.casesValue = {
                            startsWith: results[0].cases,
                            endsWith: results[1].cases,
                            contains: results[2].cases,
                            notContains: results[3].cases,
                        }
                    })
            } catch (err) {
                notifyError(err)
            }
        },

        async filterCases(filter) {
            const { processId } = this.$route.params
            const modelData = this.data && this.data.modelData ? this.data.modelData : {}
            const { loopUid, variantCount, variantUid } = modelData
            const id = this.data && this.data.id ? this.data.id : ''
            const params = {
                filters: [
                    {
                        id: filter,
                        values: [id],
                    },
                ],
                filterSet: [],
                operator: "AND",
                ...(loopUid !== undefined ? { loopUid } : {}),
                ...(variantCount ? { variantCount } : {}),
                ...(variantUid ? { variantUid } : {}),
            }
            return apiRequest(Api().visualizations.modelInfo({ processId, params }))
        },

        getSeverity(percent) {
            if (percent <= 30) {
                return { level: "low", color: "green" }
            } if (percent > 30 && percent <= 60) {
                return { level: "medium", color: "orange" }
            }
            return { level: "high", color: "red" }
        },

        calculateSeverityLevel() {
            const currentSeverity = this.getSeverity(this.currentWallaceCofPercent)
            const totalSeverity = this.getSeverity(this.totalWallaceCofPercent)
            this.severityLevels[0] = currentSeverity.level
            this.severityColors[0] = currentSeverity.color
            this.severityLevels[1] = totalSeverity.level
            this.severityColors[1] = totalSeverity.color
        },
        formatFilter(selectedFilter) {
            return {
                id: selectedFilter,
                values: [this.data?.id].filter(Boolean),
                meta: {
                    activity: this.data?.id,
                },
            }
        },

        checkFilterStartByEndBy(selectedFilter) {
            if (selectedFilter === 'TRACE_STARTS_WITH_ACTIVITY' || selectedFilter === 'TRACE_ENDS_WITH_ACTIVITY') {
                const { visualizationFilters } = this
                return visualizationFilters.some((f) => f.id === selectedFilter)
            }
            return false
        },

        async handleAddFilter(selectedFilter) {
            this.$eventBus.emit('addFilter', this.formatFilter(selectedFilter))
        },

        handleDeleteFilter(selectedFilter) {
            const filter = this.formatFilter(selectedFilter, true)
            this.$emit('delete-filter', filter)
            this.filters = this.filters.filter((fil) => fil.uuid !== filter.uuid)
        },

        handleClickClose() {
            this.$emit('close')
        },

        handleClickTablePopup() {
            this.$emit('open-table-popup')
        },
    },
}
</script>
<style lang="scss">
    .popupAct {
        border: 1px solid $gray-05;
        border-radius: 5px;
        background: white;
        position: absolute;
        padding: '10px';
        overflow: hidden;
        min-width: max-content;
    }

    .buttons_container {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 10px;
    }

    .button_row {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .button_row .q-btn {
        width: 170px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 15px;
        width: 100%;
    }

    .connections {
        display: flex;
        justify-content: flex-end !important;
    }

    .connectionButton {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: auto !important;
        padding: 5px 10px;
        gap: 5px;
    }

    .no-hover:hover {
        box-shadow: none;
        background-color: transparent;
    }

</style>
